import { trackView } from '../../../_common/client/tracking';

export const trackReviewImageCountOnPageImpression = (rootElement: HTMLElement) => {
    const trackedReviewImageCount = rootElement.getAttribute('data-tracked-review-image-count');
    if (trackedReviewImageCount == null) return;
    trackView({ product_ReviewImageCount: [trackedReviewImageCount] });
};
